/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";

interface CheckBoxProps {
  onCheckboxClick: (event: any) => void;
  className: string;
  isChecked?: boolean;
}

/**
 * Reusable React component - CheckBox.
 *
 * @namespace CheckBox
 */
class CheckBox extends React.Component<CheckBoxProps> {
  constructor(props: CheckBoxProps) {
    super(props);
    this.state = {
      submitted: false,
    };
  }

  /**
   * This method is used for handle checkbox click
   * @param {any} event
   *
   */
  executeCallback = (event: any) => {
    if (this.props.onCheckboxClick) {
      this.props.onCheckboxClick(event);
    }
  };

  render() {
    const { className, isChecked } = this.props;
    return (
      <div className={className}>
        <input tabIndex={0}
          type="checkbox"
          checked={isChecked}
          onClick={(evt) => this.executeCallback(evt)}
        />
        <span className="checkmark" />
      </div>
    );
  }
}

export default CheckBox;
